import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.processSteps;

export default class ProcessSteps extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      is_haccp: this.boolean(false),
      parameters: this.attr({}),
      unique_id: this.string(''),
      stages: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/process/steps',
    },
  };
}
